import {
  useMemo,
  useState,
  Dispatch,
  ReactNode,
  createContext,
  SetStateAction,
} from "react";

interface Context {
  isDatastoresMenuActive?: boolean;
  setIsDatastoresMenuActive?: Dispatch<SetStateAction<boolean>>;
  isDatastoresMenuPinned?: boolean;
  setIsDatastoresMenuPinned?: Dispatch<SetStateAction<boolean>>;
  isDatasetInfoCollapsed?: boolean;
  setIsDatasetInfoCollapsed?: Dispatch<SetStateAction<boolean>>;
}

export const MenuContext = createContext<Context>({});

interface MenuProviderProps {
  children: ReactNode;
}

export const MenuProvider = ({ children }: MenuProviderProps) => {
  const [isDatastoresMenuPinned, setIsDatastoresMenuPinned] = useState(false);
  const [isDatastoresMenuActive, setIsDatastoresMenuActive] = useState(false);
  const [isDatasetInfoCollapsed, setIsDatasetInfoCollapsed] = useState(false);

  const context: Context = useMemo(
    () => ({
      isDatastoresMenuActive,
      setIsDatastoresMenuActive,
      isDatastoresMenuPinned,
      setIsDatastoresMenuPinned,
      isDatasetInfoCollapsed,
      setIsDatasetInfoCollapsed,
    }),
    [
      isDatastoresMenuActive,
      setIsDatastoresMenuActive,
      isDatastoresMenuPinned,
      setIsDatastoresMenuPinned,
      isDatasetInfoCollapsed,
      setIsDatasetInfoCollapsed,
    ]
  );

  return (
    <MenuContext.Provider value={context}>{children}</MenuContext.Provider>
  );
};
